import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Activity } from "lucide-react";

export default function TradeTicker() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/portfolio/trade-ticker").then(r => setItems(r.data.items || [])).catch(() => {}); }, []);
  if (!items.length) return null;
  const render = (it, i) => (
    <span key={i} className="inline-flex items-center gap-2 mx-6 text-xs font-mono">
      <span className="text-[var(--accent)]">[{it.league}]</span>
      <span className="text-[var(--text-2)]">{it.players.join(" · ")}{it.picks ? `${it.players.length ? " + " : ""}${it.picks} pick${it.picks > 1 ? "s" : ""}` : ""}</span>
      <span className="text-[var(--text-3)]">↔</span>
    </span>
  );
  return (
    <div className="border-t border-[var(--border)] bg-[var(--elev)] h-8 flex items-center overflow-hidden shrink-0" data-testid="trade-ticker">
      <div className="flex items-center gap-2 px-3 border-r border-[var(--border)] h-full shrink-0">
        <Activity className="w-3.5 h-3.5 text-[var(--accent)]" />
        <span className="text-[9px] tracking-widest font-mono text-[var(--text-3)] hidden sm:block">TRADE TAPE</span>
      </div>
      <div className="overflow-hidden flex-1">
        <div className="ticker-track">
          {items.map(render)}
          {items.map((it, i) => render(it, i + 1000))}
        </div>
      </div>
    </div>
  );
}
